import { CITATION_NODE_DATA_ATTRIBUTE } from '../CitationPlugin/CitationNode';

interface PrepareHtmlForClipboardOptions {
  includeCitationNodes: boolean;
}

/**
 * Normalizes rich clipboard HTML for external editors and includes internal
 * citation metadata only when the caller requested citation-aware copy.
 */
export function prepareHtmlForClipboard(
  htmlString: string,
  { includeCitationNodes }: PrepareHtmlForClipboardOptions
): string {
  const parser = new DOMParser();

  // Parse the HTML string into a Document object
  const doc = parser.parseFromString(htmlString, 'text/html');

  const allElements = doc.querySelectorAll('*');

  allElements.forEach((element) => {
    if (
      Array.from(element.classList).some((className) =>
        className.includes('nestedListItem')
      ) &&
      element.tagName === 'LI'
    ) {
      // Replace the element with its child nodes
      const parent = element.parentNode;

      if (parent) {
        // Move all child nodes of the element to the parent
        while (element.firstChild) {
          parent.insertBefore(element.firstChild, element);
        }

        // Remove the empty element itself
        parent.removeChild(element);
      }
    }
  });

  if (!includeCitationNodes) {
    doc
      .querySelectorAll(`[${CITATION_NODE_DATA_ATTRIBUTE}]`)
      .forEach((element) => element.remove());
  }

  // Return the modified HTML string
  return doc.documentElement.outerHTML;
}
